(() => {
	const newsFilters = document.querySelectorAll('.blog-filters__select');

	if (newsFilters.length > 0) {
		newsFilters.forEach(filter => {
			filter.addEventListener('change', e => {

				const { name, value } = e.target;
				const urlParams = new URLSearchParams(window.location.search);

				if (urlParams.has(name)) {
					if (value == '') {
						urlParams.delete(name);
					} else {
						urlParams.set(name, value);
					}
				} else if (value != '') {
					urlParams.append(name, value);
				}

				const url = window.location.pathname;
				const parameterString = urlParams != '' ? `?${urlParams}` : '';
				const combinedUrl = `${url}${parameterString}`;

				window.location.href = combinedUrl;
			});
		});
	}
})();
